import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { FlexContainer, Heading } from "../../constants/assets/containers";
import Input from "sushiweb/InputTypes/Input";
import styles from "../../constants/assets/variables";
import HorizontalTabs from "sushiweb/HorizontalTabs";
import AddressButtonSecondary from "sushiweb/Order/AddressButtonSecondary";
import Button from "sushiweb/Button";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import QcDriverDocumentDetails from "../../components/QcDetails/QcDriverDocumentDetails";
import DlRcDocumentDetailsEdit from "../../components/DlRcDetails/DlRcDocumentDetailsEdit";
import EvQcDetails from "../../components/DlRcDetails/EvQcDetails";
import {
  approveDlRcDetails,
  getDlRcDetails,
  getDlRcAdditionalData,
  resetState,
  saveDlRcDetails,
  setDlRcDetails,
  setEvDetails,
} from "../../store/actions/DlRcDetails";
import {
  capitalizeFirstLetter,
  debounce,
  getPath,
  isEmpty,
  isMobile,
  isValNull,
} from "../../utils";
import BlankState from "../../components/Common/BlankState";
import variables from "../../constants/assets/variables";
import { shouldQcApproved } from "../../components/DlRcDetails/Helper";
import { handleQcValidations } from "../../components/QcDetails/HelperFunctions";
import ConfirmationModal from "../../components/Common/ConfirmationModal";
import ErrorModal from "../../components/Common/ErrorModal";
import MenuNames from "../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import Permission from "../../components/Common/Permission";
import { useParams } from "react-router-dom";

const detailTabs = ["Documents"];
const DlRcRejectPresentCheck = ["dl_", "rc_"];

var interval = null;

const DlRcDetails = ({
  getDlRcDetails,
  getDlRcAdditionalData,
  approveDlRcDetails,
  saveDlRcDetails,
  dlRcDetails,
  evDetails,
  currentActiveFeId,
  dlRcRejectionReasons,
  evAdditionalData,
  dlRcDocTypes,
  setDlRcDetails,
  resetState,
}) => {
  const history = useHistory();
  const { Feid } = useParams();
  const [activeIndex, setActiveIndex] = useState("Details");
  const [saveState, setSaveState] = useState(false);
  const [currentFeId, setCurrentFeId] = useState("");
  const [editableField, setEditableField] = useState("");
  const [showSingleFieldEditOptions, setShowSingleFieldEditOptions] =
    useState("");
  const [initialState, setInitialState] = useState({});
  const [showQcButton, setShowQcButton] = useState(false);
  const [dlRcApproved, setDlRcApproved] = useState(false);
  const [dlRcPartiallyApproved, setDlRcPartiallyApproved] = useState(false);
  const [showQcApproveModal, setShowQcApproveModal] = useState(false);
  const [showRcDependentFields, setShowRcDependentFields] = useState(false);
  const [errors, setErrors] = useState([]);
  const allActions = MenuActionsMappings[MenuNames.DLRC_CHECK];
  const onboardingFlow = getPath(dlRcDetails, "onboarding_flow", "");
  const editStateError = `${capitalizeFirstLetter(
    editableField.split("_").join(" ")
  )} field is in edit state, please save or cancel changes before moving forward`;

  const handleTabClick = (val) => {
    setActiveIndex(val);
  };

  const handleVerifyClick = () => {
    setSaveState(true);
  };

  const isVerifyDisabled = () => {
    if (dlRcDetails.qc_status == "APPROVED") {
      return true;
    }
    return false;
  };

  const getSavePayload = () => {
    let payload = {};

    if (initialState.document_details.dl_doc.hasOwnProperty("verified")) {
      if (
        initialState.document_details.dl_doc.verified ||
        DlRcRejectPresentCheck.includes(
          initialState.document_details.dl_doc.rejection_reason.slice(0, 3)
        )
      ) {
        payload["dl_doc"] = {
          verified: initialState.document_details.dl_doc.verified || false,
          rejection_reason:
            initialState.document_details.dl_doc.rejection_reason || "",
          expiry_date: initialState.document_details.dl_doc.expiry || "",
        };
      }
    }

    if (initialState.document_details.rc_doc.hasOwnProperty("verified")) {
      if (
        initialState.document_details.rc_doc.verified ||
        DlRcRejectPresentCheck.includes(
          initialState.document_details.rc_doc.rejection_reason.slice(0, 3)
        )
      ) {
        payload["rc_doc"] = {
          verified: initialState.document_details.rc_doc.verified || false,
          rejection_reason:
            initialState.document_details.rc_doc.rejection_reason || "",
          expiry_date: initialState.document_details.rc_doc.expiry || "",
        };
      }
    }

    if (initialState.document_details.rc_doc.verified) {
      if (
        getPath(initialState, "document_details.pucc_doc", {}).hasOwnProperty(
          "verified"
        )
      ) {
        if (
          initialState.document_details.pucc_doc.verified ||
          DlRcRejectPresentCheck.includes(
            initialState.document_details.pucc_doc.rejection_reason.slice(0, 3)
          )
        ) {
          payload["pucc_doc"] = {
            verified: initialState.document_details.pucc_doc.verified || false,
            rejection_reason:
              initialState.document_details.pucc_doc.rejection_reason || "",
            expiry_date: initialState.document_details.pucc_doc.value || "",
          };
        }
      }
      if (
        initialState.document_details.insurance_doc.hasOwnProperty("verified")
      ) {
        if (
          initialState.document_details.insurance_doc.verified ||
          DlRcRejectPresentCheck.includes(
            initialState.document_details.insurance_doc.rejection_reason.slice(
              0,
              3
            )
          )
        ) {
          payload["insurance_doc"] = {
            verified:
              initialState.document_details.insurance_doc.verified || false,
            rejection_reason:
              initialState.document_details.insurance_doc.rejection_reason ||
              "",
            expiry_date:
              initialState.document_details.insurance_doc.value || "",
          };
        }
      }
    }

    return payload;
  };

  const handleCancelClick = () => {
    setSaveState(false);
    setEditableField("");
    setShowSingleFieldEditOptions("");
    const payload = {
      document_details: dlRcDetails.document_details
        ? JSON.parse(JSON.stringify(dlRcDetails.document_details))
        : {},
    };
    if (!dlRcApproved) {
      setInitialState(payload);
    }
    if (!dlRcApproved && shouldQcApproved(payload)) {
      setShowQcButton(true);
    } else {
      setShowQcButton(false);
    }
    setShowRcDependentFields(false);
  };

  const handleSaveClick = () => {
    if (editableField !== "") {
      setErrors([editStateError]);
      return;
    }
    const validationErrors = handleQcValidations(initialState, dlRcDetails);
    if (validationErrors.length > 0) {
      setErrors(validationErrors);
      return;
    }
    const payload = getSavePayload();

    saveDlRcDetails(currentActiveFeId, payload).then((res) => {
      if (res) {
        setEditableField("");
        setShowSingleFieldEditOptions("");
        getDlRcDetails(currentActiveFeId);
      }
    });
  };

  const handleVerifiedChange = (item, val, inKey) => {
    console.log(item, val, inKey);
    const values = { ...initialState };
    val = val === "true" ? true : false;
    if (val) {
      values[inKey][item.key]["rejection_reason"] = "";
    }
    values[inKey][item.key]["verified"] = val;
    if (item.key === "rc_doc") {
      val ? setShowRcDependentFields(true) : setShowRcDependentFields(false);
    }
    if (!dlRcApproved && shouldQcApproved(values)) {
      setShowQcButton(true);
    } else {
      setShowQcButton(false);
    }
    setInitialState(values);
  };

  const handleRejectionReasonChange = (keyToChange, val, extraParams) => {
    const item = extraParams[0];
    const inKey = extraParams[1];
    const values = { ...initialState };
    values[inKey][item.key]["rejection_reason"] = val;
    setInitialState(values);
  };

  const handleDocTypeChange = (keyToChange, val, extraParams) => {
    const item = extraParams[0];
    const inKey = extraParams[1];
    const values = { ...initialState };
    values[inKey][item.key]["doc_type"] = val;
    setInitialState(values);
  };

  const handleQcApprove = () => {
    const validationErrors = handleQcValidations(initialState, dlRcDetails);
    if (validationErrors.length > 0) {
      setErrors(validationErrors);
      setShowQcApproveModal(false);
      return;
    }
    const payload = getSavePayload();
    saveDlRcDetails(currentActiveFeId, payload).then((res) => {
      if (res) {
        setEditableField("");
        setShowSingleFieldEditOptions("");
        getDlRcDetails(currentActiveFeId);
      }
    });
  };

  const handleQcApproveClickButton = () => {
    if (editableField !== "") {
      setErrors([editStateError]);
      return;
    }
    setShowQcApproveModal(true);
  };

  const handleQcApproveCancelButton = () => {
    setShowQcApproveModal(false);
  };

  const getTabData = () => {
    return saveState ? (
      <DlRcDocumentDetailsEdit
        onboardingFlow={onboardingFlow}
        editableField={editableField}
        initialState={initialState}
        setInitialState={setInitialState}
        details={dlRcDetails}
        verifiedOptions={verifiedOptions}
        setEditableField={setEditableField}
        setShowSingleFieldEditOptions={setShowSingleFieldEditOptions}
        showSingleFieldEditOptions={showSingleFieldEditOptions}
        handleVerifiedChange={handleVerifiedChange}
        rejectionReasons={dlRcRejectionReasons}
        docTypes={dlRcDocTypes}
        handleRejectionReasonChange={handleRejectionReasonChange}
        handleDocTypeChange={handleDocTypeChange}
        dlRcApproved={dlRcApproved}
        permission={allActions.WRITE}
        showRcDependentFields={showRcDependentFields}
        setShowRcDependentFields={setShowRcDependentFields}
      />
    ) : (
      <QcDriverDocumentDetails details={dlRcDetails} />
    );
  };

  //custom debouncing implemented
  const getDriverQcDetails = (feid) => {
    clearTimeout(interval);
    interval = setTimeout(() => {
      setDlRcApproved(false);
      setDlRcPartiallyApproved(false);
      resetState({ state: "dlRcDetails" });
      resetState({ state: "currentActiveFeId" });
      getDlRcDetails(feid).then((res) => {
        if (res) {
          window.history.replaceState(null, null, `/dlrc-details/${feid}`);
          setShowSingleFieldEditOptions("");
          setEditableField("");
          setShowRcDependentFields(false);
        }
      });
    }, 500);
  };

  const handleInputChange = (e) => {
    setCurrentFeId(e);
    if (e) {
      getDriverQcDetails(e);
    }
  };

  const IsDlRcStatusApproved = () => {
    setDlRcPartiallyApproved(
      getPath(dlRcDetails, "qc_status", "") === "PARTIALLY_APPROVED"
    );
    setDlRcApproved(getPath(dlRcDetails, "qc_status", "") === "APPROVED");
  };

  const verifiedOptions = [
    {
      label: "Accept",
      value: true,
      disabled: dlRcApproved,
    },
    {
      label: "Reject",
      value: false,
      disabled: dlRcApproved,
    },
  ];

  const handleErrorModalSubmit = () => {
    setErrors([]);
  };

  useEffect(() => {
    ((dlRcRejectionReasons && dlRcRejectionReasons.length === 0) ||
      (dlRcDocTypes && dlRcDocTypes.length === 0)) &&
      getDlRcAdditionalData();
  }, []);

  useEffect(() => {
    if (Feid) {
      setCurrentFeId(Feid);
      getDriverQcDetails(Feid);
    }
  }, [Feid]);

  useEffect(() => {
    if (currentActiveFeId) {
      setCurrentFeId(currentActiveFeId);
      window.history.replaceState(
        null,
        null,
        `/dlrc-details/${currentActiveFeId}`
      );
    }
  }, [currentActiveFeId]);

  useEffect(() => {
    const payload = {
      basic_details: dlRcDetails.basic_details
        ? JSON.parse(JSON.stringify(dlRcDetails.basic_details))
        : {},
      document_details: dlRcDetails.document_details
        ? JSON.parse(JSON.stringify(dlRcDetails.document_details))
        : {},
    };
    if (editableField == "") {
      setInitialState(payload);
    }
    setShowQcApproveModal(false);
    if (dlRcDetails && Object.keys(dlRcDetails).length > 0) {
      if (!dlRcApproved && shouldQcApproved(payload)) {
        setShowQcButton(true);
      } else {
        setShowQcButton(false);
      }
      IsDlRcStatusApproved();
    }
  }, [dlRcDetails]);

  return [
    <QcSection>
      <FlexContainer align="flex-start">
        <Heading>DL RC Details</Heading>
        <Input
          onChange={handleInputChange}
          value={currentFeId}
          id="sushi-input"
          label="Driver FE ID"
          required
          borderColor={styles.primaryColor}
          autoFocus
        />
      </FlexContainer>
      {getPath(Object.keys(dlRcDetails), "length", 0) ? (
        <React.Fragment>
          <RightButtons>
            {saveState ? (
              <FlexContainer>
                {!showQcButton && (
                  <Permission requiredPerms={[allActions.WRITE]}>
                    <Button
                      data-testId="saveDriverDetail"
                      onClick={handleSaveClick}
                      className="sushi-btn mr-10"
                      disabled={dlRcApproved}
                    >
                      Save
                    </Button>
                  </Permission>
                )}
                {showQcButton && (
                  <Permission requiredPerms={[allActions.WRITE]}>
                    <Button
                      data-testId="dlRcApproveDriverDetail"
                      onClick={handleQcApproveClickButton}
                      className="sushi-btn mr-10"
                      disabled={dlRcApproved}
                    >
                      Qc Approve & Proceed
                    </Button>
                  </Permission>
                )}
                <Button
                  data-testId="cancelSavingQcDetail"
                  onClick={handleCancelClick}
                  className="sushi-btn"
                  appearance="outline"
                >
                  Cancel
                </Button>
              </FlexContainer>
            ) : (
              <FlexContainer justify="space-between">
                <Button
                  data-testId="verifyQcDetailsBtn"
                  className="sushi-btn mr-10"
                  appearance="outline"
                  disabled={true}
                >
                  {isValNull(dlRcDetails.qc_status)
                    ? "QC status: NA"
                    : dlRcDetails.qc_status}
                </Button>
                <Button
                  data-testId="verifyQcDetailsBtn"
                  onClick={handleVerifyClick}
                  className="sushi-btn"
                  appearance="outline"
                  disabled={isVerifyDisabled()}
                >
                  {!isValNull(dlRcDetails.qc_status) &&
                  dlRcDetails.qc_status == "APPROVED"
                    ? "Verified"
                    : "Verify"}
                </Button>
              </FlexContainer>
            )}
          </RightButtons>
          <HorizontalTabs id="sushi-tabs" className="mb-20" alignLinks="left">
            {detailTabs.map((tab, index) => {
              return (
                <HorizontalTabs.Link
                  active={activeIndex === tab}
                  onClick={() => handleTabClick(tab)}
                  key={index}
                  className={`tab${index}${activeIndex === tab}`}
                >
                  {tab}
                </HorizontalTabs.Link>
              );
            })}
          </HorizontalTabs>
          {dlRcDetails.driver_lifecycle_status === "terminated" ? (
            <p className="status-approved-message">
              *Driver is terminated. You will not be able to make changes
            </p>
          ) : dlRcApproved ? (
            <p className="status-approved-message">
              *Qc is approved already, you will no longer be able to make
              changes
            </p>
          ) : (
            <div />
          )}
          {getTabData()}
        </React.Fragment>
      ) : isValNull(evDetails) ? (
        <BlankState message="Provide valid FE Id to see details" />
      ) : (
        <EvQcDetails
          feID={currentActiveFeId}
          evDetails={evDetails}
          evAdditionalData={evAdditionalData}
        ></EvQcDetails>
      )}
      {errors.length > 0 && (
        <ErrorModal
          handleSubmit={handleErrorModalSubmit}
          heading="Error while saving"
          errors={errors}
        />
      )}
    </QcSection>,
    <ConfirmationModal
      open={showQcApproveModal}
      modalTitle="Approve request"
      onCofirmCancelHandler={handleQcApproveCancelButton}
      onCofirmSuccessHandler={handleQcApprove}
      successButtonText="Yes"
      CancelButtonText="No"
    >
      Are you sure to approve the QC?
    </ConfirmationModal>,
  ];
};

const QcSection = styled.section`
  #info-button {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  #sushi-tabs {
    margin-top: ${isMobile() ? "10px" : "-10px"};
  }
  #sushi-input {
    padding-right: unset;
  }
  .row-heading,
  .row-text {
    font-size: 0.875rem !important;
    font-weight: 500;
  }
  .customDropdown {
    margin-bottom: unset;
  }
  .inbox-dropdown {
    margin-bottom: 30px;
  }
  .fields-holder {
    padding: 30px;
  }
  .section-heading {
    margin-bottom: 20px;
  }
  .status-approved-message {
    color: ${variables.primaryColor};
    font-size: 0.875rem !important;
    margin-bottom: 20px;
  }
`;

const RightButtons = styled(FlexContainer)`
  justify-content: flex-end;
`;

export const QcFieldsContainer = styled.div``;

export const DocImg = styled.img`
  width: 200px;
  height: 200px;
  margin-bottom: 20px;
  border-radius: 8px;
  border: 1px solid ${variables.grey200};
  object-fit: contain;
  background-color: ${variables.grey200};
  justify-content: center;
  cursor: ${({ cursor = "pointer" }) => cursor};
`;

function mapStateToProps(state) {
  const { DlRcDetails } = state;
  return {
    dlRcDetails: DlRcDetails.dlRcDetails,
    evDetails: DlRcDetails.evDetails,
    currentActiveFeId: DlRcDetails.currentActiveFeId,
    dlRcRejectionReasons: DlRcDetails.dlRcRejectionReasons,
    dlRcDocTypes: DlRcDetails.dlRcDocTypes,
    evAdditionalData: DlRcDetails.evAdditionalData,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getDlRcDetails: bindActionCreators(getDlRcDetails, dispatch),
    getDlRcAdditionalData: bindActionCreators(getDlRcAdditionalData, dispatch),
    saveDlRcDetails: bindActionCreators(saveDlRcDetails, dispatch),
    approveDlRcDetails: bindActionCreators(approveDlRcDetails, dispatch),
    setDlRcDetails: bindActionCreators(setDlRcDetails, dispatch),
    setEvDetails: bindActionCreators(setEvDetails, dispatch),
    resetState: bindActionCreators(resetState, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DlRcDetails);
